import i18n from "../../../../../../constants/i18n";
import { TalkhattabatConversationType } from "../../../../../../Types";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import getCorePopUpStore from "../../../../../../stores/core/core-popup-store";
import getKhattabatStore from "../../../../../../stores/khattabat-stores";

const ReactivateConversation = withLiteObserverAndTheme<{
  conversationID: string;
  conversationType: TalkhattabatConversationType;
  exitedByMatch: boolean;
  exitedByClient: boolean;
  alkhattabaUUID: string;
  userUUID: string;
  oneOOneCId: string
}>((props) => {
  const {
    theme,
    conversationType,
    conversationID,
    exitedByClient,
    exitedByMatch,
    userUUID,
    alkhattabaUUID,
    oneOOneCId
  } = props;
  const { colors, unitX } = theme;
  const isOneOTwoConversation = conversationType === "102";
  const shouldShow = isOneOTwoConversation;
  const isConversationExitExists = exitedByClient || exitedByMatch;

  return !shouldShow ? null : (
    <ET3Div
      width={180}
      height={43}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        backgroundColor: isConversationExitExists
          ? colors.all.green
          : colors.all.gray,
        borderRadius: 36 * unitX,
        cursor: "pointer"
      }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={async () => {
        if (isConversationExitExists) {
          getKhattabatStore().setReactivateOneOTwoConversationProps({
            userUUID,
            alkhattabaUUID,
            conversationID,
            oneOOneCId
          });
          getCorePopUpStore().openConfirmationPopUps(
            "ONE_O_TWO_CONFIRMATION_POPUP"
          );
        }
      }}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={24}
        isSpan={false}
        text={i18n.get("REACTIVATE")}
        style={{}}
        color={colors.all.white}
      />
    </ET3Div>
  );
});

export default ReactivateConversation;
